export default {
  path: '/lvy-user-authority-agreement',
  component: () => import('./LVYUserAuthorityAgreement'),
  meta: {
    title: '用户授权协议',
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}